var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRutas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8C4.74028 8 5.38663 7.5978 5.73244 7H15.5002C16.6047 7 17.5002 7.89543 17.5002 9C17.5002 10.1046 16.6047 11 15.5002 11H8.50016C6.29102 11 4.50016 12.7909 4.50016 15C4.50016 17.2091 6.29102 19 8.50016 19H18.2676C18.6134 19.5978 19.2597 20 20 20C21.1046 20 22 19.1046 22 18C22 16.8954 21.1046 16 20 16C19.2597 16 18.6134 16.4022 18.2676 17H8.50016C7.39559 17 6.50016 16.1046 6.50016 15C6.50016 13.8954 7.39559 13 8.50016 13H15.5002C17.7093 13 19.5002 11.2091 19.5002 9C19.5002 6.79086 17.7093 5 15.5002 5H5.73244C5.38663 4.4022 4.74028 4 4 4C2.89543 4 2 4.89543 2 6C2 7.10457 2.89543 8 4 8Z",
    fill: "#1C1F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRutas);
export default __webpack_public_path__ + "static/media/Ic_Rutas.8021484746994d5f4f40580c579f8f6f.svg";
export { ForwardRef as ReactComponent };